/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'app/shared/services/common.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  constructor(private router: Router, private commonService: CommonService, private zone: NgZone) {}

  ngOnInit() {}

  public redirectToLogin() {
    this.zone.run(() => {
      this.router.navigateByUrl('login');
    });
  }

  public redirectToCallidus() {
    window.location.href = 'https://www.vorwerk.com/';
  }
}
